/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {Fragment, FC, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {toAbsoluteUrl} from '../../../../../../_metronic/helpers'
import {PDFCard} from '../../../../../../_metronic/partials/content/cards/PDFCard'
import { PDFLinkCard } from '../../../../../../_metronic/partials/content/cards/PDFLinkCard'
import { PublicationModel, useAuth } from '../../../../auth'
import { getPDFURL, listPersonalPublication } from '../../../../auth/core/_api'

function getColor(status:string){
  if(status == 'published'){
    return 'text-success'
  }
  else if(status == 'commented'){
    return 'text-warning'
  }
  else if(status == 'submitted'){
    return 'text-primary'
  }
  else if(status == 'rejected'){
    return 'text-danger'
  }
  else{
    return 'text-info'
  }
}

function getStatusText(status:string){
  if(status == 'drafted'){
    return 'บันทึกร่าง'
  }
  else if(status == 'published'){
    return 'เผยแพร่สาธารณะแล้ว'
  }
  else if(status == 'commented'){
    return 'แจ้งกลับรอการแก้ไข'
  }
  else if(status == 'submitted'){
    return 'รอตรวจสอบ'
  }
  else if(status == 'rejected'){
    return 'ปฏิเสธการเผยแพร่'
  }
  else{
    return status
  }
}

const Publications: FC = () => {
  const { currentUser } = useAuth()
  const [publications, setPublication] = useState<PublicationModel[]>()
  
  useEffect(() => {
    async function updatePersonalPublication() {
      try {
          if(currentUser){
            const publications = await listPersonalPublication(`${currentUser.id}`)
            var publication_arr = new Array<PublicationModel>()
            publications.data.articles.forEach((publication: PublicationModel) => {
              publication_arr.push(publication)
            });
            setPublication(publication_arr)
            //alert(publication_arr.length)
          }
      } catch (error) {
          //setLoading(false)
      }
    };
    updatePersonalPublication()
  }, []);
  
  {/*const questions = [
    {
      title: 'การพัฒนาประเทศรัสเซียตามแผนพัฒนาเศรษฐกิจและสังคมแห่งชาติปี ค.ศ. 2019 - 2024 ในด้านการพัฒนาและการลงทุนโครงสร้างพื้นฐาน',
      description:
        'การศึกษาเรื่องการพัฒนาประเทศรัสเซียตามแผนพัฒนาเศรษฐกิจและสังคมแห่งชาติปี ค.ศ. 2019 - 2024 ในด้านการพัฒนาและการลงทุนโครงสร้างพื้นฐานมีวัตถุประสงค์เพื่อการศึกษาถึงภาพรวมของการพัฒนาโครงสร้างพื้นฐานของประเทศรัสเซียในแผนพัฒนาเศรษฐกิจและสังคมแห่งชาติ ตลอดจนถึงการศึกษาประโยชน์จากการพัฒนาโครงสร้างพื้นฐาน...',
      doc_type: 'ภาคนิพนธ์',
      degree: "ศิลปศาสตร์บัณฑิต",
      date: '24 ก.พ 2565',
      status: 'published'
    },
    {
      title: 'อิทธิพลวัฒนธรรมเพลงฮิปฮอปในประเทศรัสเซีย',
      description:
        'ภาคนิพนธ์เรื่อง “วัฒนธรรมฮิปฮอปในประเทศรัสเซีย” เป็นวิจัยเชิงคุณภาพ มีวัตถุประสงค์เพื่อศึกษาที่มาและความสำคัญของวัฒนธรรมฮิปฮอปและวัฒนธรรมฮิปฮอปในรัสเซีย นอกจากนี้ยังมีการศึกษาภาพสะท้อนสังคมจากวัฒนธรรมฮิปฮอปอีกด้วย ผลการศึกษาพบว่า วัฒนธรรมฮิปฮอปในรัสเซียได้รับเข้ามาจากวัฒนธรรมฮิปฮฮปในประเทศสหรัฐอเมริกาจากการปรับ..',
      doc_type: 'ภาคนิพนธ์',
      degree: "ศิลปศาสตร์บัณฑิต",
      date: '24 ก.พ 2565',
      status: 'commented'
    },
    {
      title: 'การย้ายเมืองราชการของมาเลเซียจากเมืองกัวลาลัมเปอร์ไปยังเมืองปุตราจายา',
      description:
        'ภาคนิพนธ์เรื่อง “วัฒนธรรมฮิปฮอปในประเทศรัสเซีย” เป็นวิจัยเชิงคุณภาพ มีวัตถุประสงค์เพื่อศึกษาที่มาและความสำคัญของวัฒนธรรมฮิปฮอปและวัฒนธรรมฮิปฮอปในรัสเซีย นอกจากนี้ยังมีการศึกษาภาพสะท้อนสังคมจากวัฒนธรรมฮิปฮอปอีกด้วย ผลการศึกษาพบว่า วัฒนธรรมฮิปฮอปในรัสเซียได้รับเข้ามาจากวัฒนธรรมฮิปฮฮปในประเทศสหรัฐอเมริกาจากการปรับ..',
      doc_type: 'ภาคนิพนธ์',
      degree: "ศิลปศาสตร์บัณฑิต",
      date: '24 ก.พ 2565',
      status: 'submitted'
    },
    {
      title: 'การศึกษาเปรียบเทียบชาวเชเชนในรัสเซียกับชาวอุยกูร์ในจีนเกี่ยวกับ นโยบายการกลืนชาติในตงั้แต่ศตวรรษที่ 17 จนถึง ค.ศ.2021',
      description:
        'ภาคนิพนธ์ฉบับนี้ศึกษาการเปรียบเทียบชาวเชเชนในรัสเซียและชาวอุยกูร์จีนเกี่ยวกับนโยบายการกลืนชาติตั้งแต่อดีตจนถึงปัจจุบัน โดยในการศึกษาครั้งนี้ผู้วิจัยได้ทำการศึกษาถึงความเป็นมาของชาวเชเชนกับชาวอุยกูร์กับการที่ถูกประเทศมหาอำนาจอย่างประเทศรัสเซียและประเทศจีนยึดครองและกลืนชาติ..',
      doc_type: 'ภาคนิพนธ์',
      degree: "ศิลปศาสตร์บัณฑิต",
      date: '24 ก.พ 2565',
      status: 'rejected'
    },
  ]*/}

  return (
    <>
      <div className='mb-10'>
        {publications && publications.map((item, i) => {
          return (
            <Fragment key={`question_${i}`}>
              <div className='mb-0'>
                <div className='d-flex align-items-center mb-4'>
                  <Link
                    //to='/apps/devs/question'
                    to={`/home/article?doc_type=${item.doc_type}`}
                    className='fs-2 fw-bolder text-gray-900 text-hover-primary me-1'
                  >
                    {item.title}
                  </Link>
                </div>

                <div className='fs-base fs-3 text-gray-700 mb-4'>{item.description && item.description.substring(0, 250)}{item.description && '...'}</div>

                <div className='d-flex flex-stack flex-wrap'>
                  <div className='d-flex align-items-center py-1'>
                    <div className='symbol symbol-35px me-2'>
                      <PDFLinkCard icon='/media/svg/files/pdf.svg' title='View' url={(item.pdf_file)?getPDFURL(item.pdf_file):"#"} />
                    </div>

                    <div className='d-flex flex-column align-items-start justify-content-center'>
                    <span className='text-gray-900 fs-7 fw-bold lh-1 mb-2'>{item.doc_type}</span>
                      <span className='text-muted fs-7 lh-1 mb-2'>{item.degree_name}</span>
                      <span className='text-muted fs-8 fw-bold lh-1'>{item.date}</span>
                    </div>
                  </div>

                  <div className='d-flex align-items-center py-1'>
                  <span
                      className={`px-4 me-2 ${getColor(item.status)}`}
                    >
                      {getStatusText(item.status)}
                    </span>

                    {(item.status == 'submitted' || item.status =='commented' || item.status =='drafted')? <Link
                      to={`/personal_publication/publication_add?pid=${item.id}`}
                      className='btn btn-sm btn-outline btn-light-primary btn-outline-dashed px-4 me-2'
                    >
                      แก้ไขรายละเอียด <i className="ms-1 bi bi-pencil"></i>
                    </Link>:
                    <Link
                      to={`/personal_publication/publication_detail?pid=${item.id}`}
                      className='btn btn-sm btn-outline btn-light-primary btn-outline-dashed px-4 me-2'
                    >
                      แสดงรายละเอียด <i className="ms-1 bi bi-arrow-right-circle"></i>
                    </Link>
                    }

                  </div>
                </div>
              </div>{' '}
              <div className='separator separator-dashed border-gray-300 my-8'></div>
            </Fragment>
          )
        })}
      </div>

      {/*<div className='d-flex flex-center mb-0'>
        <a
          href='#'
          className='btn btn-icon btn-light btn-active-light-primary h-30px w-30px fw-bold fs-6 mx-2'
        >
          1
        </a>
        <a
          href='#'
          className='btn btn-icon btn-light btn-active-light-primary h-30px w-30px fw-bold fs-6 mx-2 active'
        >
          2
        </a>
        <a
          href='#'
          className='btn btn-icon btn-light btn-active-light-primary h-30px w-30px fw-bold fs-6 mx-2'
        >
          3
        </a>
        <a
          href='#'
          className='btn btn-icon btn-light btn-active-light-primary h-30px w-30px fw-bold fs-6 mx-2'
        >
          4
        </a>
        <a
          href='#'
          className='btn btn-icon btn-light btn-active-light-primary h-30px w-30px fw-bold fs-6 mx-2'
        >
          5
        </a>
        <span className='text-muted fw-bold fs-6 mx-2'>..</span>
        <a
          href='#'
          className='btn btn-icon btn-light btn-active-light-primary h-30px w-30px fw-bold fs-6 mx-2'
        >
          19
        </a>
      </div> */}
    </>
  )
}

export {Publications}
